import { createEntityAdapter } from '@reduxjs/toolkit';

const publishersAdapter = createEntityAdapter();

export default publishersAdapter;
